import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchMarketIntelDetailAction = (postData) => {
    return async function (dispatch) {
        // const tempBaseUrl = "https://apim-na.dev.mypepsico.com/cgf/buyers-console-api/v1"; // TO BE CHANGED
        // const data = await postApiCall(`${tempBaseUrl}/market-intelligence/kpi-page-data`, postData)

        const data = await postApiCall(`${appConstants.BASE_URL}/market-intelligence/kpi-page-data`, postData);
        var resData = Object.assign({ type: 'SUCCESS_MARKET_INTEL_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchMarketIntelInHouseDetailAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/market-intelligence/mi-kpi-page-data`, postData);
        var resData = Object.assign({ type: 'SUCCESS_MARKET_INTEL_INHOUSE_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchSmartCubeCategoryAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/market-intelligence/dropdown-data`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_CATEGORY_ACTION', data });
        dispatch(resData);
    };
};

export {
    FetchMarketIntelDetailAction,
    FetchMarketIntelInHouseDetailAction,
    FetchSmartCubeCategoryAction
}